import React from "react";
import type { IconProps } from "./type";
import { COLORS } from "@/app/common/consts/colors";

const RefreshIcon = ({ color = "lightWhite" }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M4.62747 15.1111C5.03234 16.0694 5.61857 16.9323 6.34315 17.6569C7.06772 18.3814 7.93064 18.9677 8.88889 19.3725C9.84523 19.7766 10.8965 20 12 20C13.1035 20 14.1548 19.7766 15.1111 19.3725C16.0694 18.9677 16.9323 18.3814 17.6569 17.6569C18.3814 16.9323 18.9677 16.0694 19.3725 15.1111C19.7766 14.1548 20 13.1035 20 12C20 10.8965 19.7766 9.84523 19.3725 8.88889C18.9677 7.93064 18.3814 7.06772 17.6569 6.34315C16.9323 5.61857 16.0694 5.03234 15.1111 4.62747C14.1548 4.22341 13.1035 4 12 4C10.8965 4 9.84523 4.22341 8.88889 4.62747C6.9724 5.4372 5.4372 6.9724 4.62747 8.88889M4.62747 8.88889L4 4M4.62747 8.88889H9.5"
        stroke={COLORS[color]}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default RefreshIcon;
